import React, { useEffect, useRef } from 'react';
import { useVideoInputs } from 'amazon-chime-sdk-component-library-react';
import { LocalCameraWrap } from './style';

const LocalCameraPreview = ({ cssText }) => {
  const videoRef = useRef(null);
  const { selectedDevice } = useVideoInputs();

  useEffect(() => {
    let localStream = null;
    let cancelled = false;
    const deviceId =
      typeof selectedDevice === 'string'
        ? selectedDevice
        : selectedDevice?.deviceId || null;

    const constraints = deviceId
      ? { video: { deviceId: { exact: deviceId } }, audio: false }
      : { video: true, audio: false };

    navigator.mediaDevices
      .getUserMedia(constraints)
      .then((stream) => {
        if (cancelled) {
          stream.getTracks().forEach((track) => track.stop());
          return;
        }
        localStream = stream;
        const video = videoRef.current;
        if (!video) {
          stream.getTracks().forEach((track) => track.stop());
          return;
        }
        video.srcObject = stream;
        video.onloadedmetadata = () => {
          video.play?.().catch(() => {});
        };
      })
      .catch(() => {});

    return () => {
      if (videoRef.current) {
        videoRef.current.srcObject = null;
      }
      if (localStream) {
        localStream.getTracks().forEach((track) => track.stop());
      }
      cancelled = true;
    };
  }, [selectedDevice]);

  return (
    <LocalCameraWrap>
      <style>{`.local-camera-preview { ${cssText} border-radius: inherit; overflow: hidden; } .local-camera-preview video { width: 100%; height: 100%; object-fit: contain; object-position: center; border-radius: inherit; }`}</style>
      <div className="local-camera-preview">
        <video ref={videoRef} autoPlay muted playsInline style={{ transform: 'scaleX(-1)' }} />
      </div>
    </LocalCameraWrap>
  );
};

export default LocalCameraPreview;
